// extracted by mini-css-extract-plugin
export var list = "List-module--list--n+JGT";